import type { TFunction } from 'i18next'

// Toast titles for each review-queue action. Keeps success/failure pairs
// adjacent so adding a new action (e.g. resubmit) is one line in two places.
export const REVIEW_FEEDBACK_KEYS = {
  approve: { success: 'approve_success', failed: 'approve_failed' },
  decline: { success: 'decline_success', failed: 'decline_failed' },
  revoke: { success: 'revoke_success', failed: 'revoke_failed' },
  ai_review: { success: 'ai_review_success', failed: 'ai_review_failed' }
} as const

export type ReviewAction = keyof typeof REVIEW_FEEDBACK_KEYS

// Single source of truth for the success/failure toast text. Callers pass
// the user's decision (or 'ai_review') and the t() bound to keyPrefix
// 'widgets.aiAgent'. Use TFunction for the call sites and cast to a
// minimal shape here so the union literal key type stays assignable to
// i18next's overloaded signatures.
export const reviewFeedback = (
  action: ReviewAction,
  outcome: 'success' | 'failed',
  t: TFunction
): { title: string; subTitle: string } => {
  const translate = t as unknown as (key: string) => string
  return {
    title: translate(REVIEW_FEEDBACK_KEYS[action][outcome]),
    subTitle: '' // reserved for future per-action subtitles; the title alone is enough today
  }
}
